// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1MjTn","head":"ProcedureTableInfo_head__2SSem"};